import { render, staticRenderFns } from "./Home.m.vue?vue&type=template&id=31ed2228&scoped=true&"
import script from "./Home.m.vue?vue&type=script&lang=js&"
export * from "./Home.m.vue?vue&type=script&lang=js&"
import style0 from "./Home.m.vue?vue&type=style&index=0&id=31ed2228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed2228",
  null
  
)

export default component.exports